import { getLocalStorageValue } from "../local-storage";

type TagManagerEvent = Record<string, unknown> & {};

type GoogleTagManagerEvent = TagManagerEvent & {
  event: string;
};

type JentisTagManagerEvent = TagManagerEvent & {
  track: string;
};

type WindowWithDataLayer = {
  dataLayer?: {
    push: (event: TagManagerEvent) => void;
  };
};

type WindowWithJentis = {
  _jts?: {
    push: (track: JentisTagManagerEvent, resetDataLayer: boolean) => void;
  };
};

const _emitEvent = (commandName: string, data: object, isSpaEvent: boolean) => {
  if (!data) {
    return;
  }

  let sendData = { ...data };

  if (!("gaClientId" in data)) {
    const gaClientId = getLocalStorageValue("ga:clientId");

    if (!!gaClientId) {
      sendData = {
        gaClientId,
        ...data
      };
    }
  }

  const gtmWindow = window as WindowWithDataLayer;
  if (gtmWindow?.dataLayer) {
    const gtmEvent = { event: commandName, ...sendData } as GoogleTagManagerEvent;
    gtmWindow.dataLayer.push(gtmEvent);
  }
  const jtsWindow = window as WindowWithJentis;
  if (jtsWindow._jts) {
    const jtsEvent = { track: commandName, ...sendData } as JentisTagManagerEvent;
    jtsWindow._jts.push(jtsEvent, isSpaEvent);
  }
};

export const emitEvent = (
  commandName: string,
  data: Record<string, unknown>,
  isSpaEvent: boolean
) => {
  _emitEvent(commandName, data, isSpaEvent);
};

export const addtagManagerEventListener = (
  selector: string,
  nativeEventName: string,
  tagManagerEventName: string,
  dataAttributeNames?: string[]
) => {
  const elements = document.querySelectorAll(selector);

  if (!elements.length) {
    return;
  }

  elements.forEach(element => {
    element.addEventListener(nativeEventName, () => {
      const tagManagerEvent: TagManagerEvent = {};

      const toCamelCase = (input: string) =>
        input.replace(/-\w/g, matches => matches[1].toUpperCase());

      if (dataAttributeNames?.length) {
        for (const attr of dataAttributeNames) {
          const propName = toCamelCase(attr.replace("data-", ""));
          let attributeValue: string | number | null = element.getAttribute(attr);

          const numberValue = parseInt(attributeValue?.length ? attributeValue : "");

          if (!isNaN(numberValue)) {
            attributeValue = numberValue;
          }

          tagManagerEvent[propName] = attributeValue;
        }
      }

      _emitEvent(tagManagerEventName, tagManagerEvent, false);
    });
  });
};
